import etc from './etc';
import mavlink from './mavlink';

const commandSet = {};
etc.forEach((command) => {
  commandSet[command.id] = command;
});
mavlink.forEach((command) => {
  commandSet[command.id] = command;
});

export default commandSet;
